// material-ui
import { Link, Typography, Stack } from '@mui/material';

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

const AuthFooter = () => (
  <Stack direction="row" justifyContent="space-between">
    <Typography variant="subtitle2" underline="hover">
      ©2025 by ChronoTrack. All rights reserved.
    </Typography>
  </Stack>
);

export default AuthFooter;
